module.exports = __webpack_public_path__ + "static/media/jjzhIcon.0b7a9f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/jjzhIcon.png
// module id = 660
// module chunks = 0 1